import React, { Component } from 'react'
import { connect } from 'react-redux'
import DayPicker, { DateUtils } from 'react-day-picker'
import dayjs from 'dayjs'
import { actions, Control, Errors } from 'react-redux-form'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'

import RequestFormStepButtons from './stepButtons'
import SemanticInput from '../../semanticInput'
import RequestFormStep2ArrivalDays from './step2ArrivalDays'
import Card from '../../utils/Card'
import Label from '../../utils/Label'

// DayPicker-wrapper
// DayPicker-Months
// DayPicker-Month
// DayPicker-NavBar
// DayPicker-NavButton
// DayPicker-Caption
// DayPicker-Weekdays
// DayPicker-Weekday
// DayPicker-WeekdaysRow
// DayPicker-Body
// DayPicker-Week
// DayPicker-Day
// DayPicker-WeekNumber
// DayPicker--interactionDisabled .DayPicker-Day
// DayPicker-Footer
// DayPicker-TodayButton
// DayPicker-Day--today
// DayPicker-Day--outside
// DayPicker-Day--disabled
// DayPicker-Day--selected

const Navbar = ({ onPreviousClick, onNextClick, className }) => {
  const styleLeft = {
    float: 'left'
  }
  const styleRight = {
    float: 'right'
  }
  return (
    <div className={className}>
      <button style={styleLeft} onClick={() => onPreviousClick()}>
        <FontAwesomeIcon icon={faChevronLeft} className="text-3xl" />
      </button>
      <button style={styleRight} onClick={() => onNextClick()}>
        <FontAwesomeIcon icon={faChevronRight} className="text-3xl" />
      </button>
    </div>
  )
}

const connected = connect(store => {
  return {
    dateStart: store.availabilityRequestForm.dateStart,
    dateEnd: store.availabilityRequestForm.dateEnd,
    step2Valid: store.forms.availabilityRequestForm.$form.valid
  }
})
export class RequestFormStep2 extends Component {
  handleDayClick = day => {
    const range = DateUtils.addDayToRange(day, {
      from: this.props.dateStart,
      to: this.props.dateEnd
    })
    this.props.dispatch(actions.change('availabilityRequestForm.dateStart', range.from))
    this.props.dispatch(actions.change('availabilityRequestForm.dateEnd', range.to))
  }
  handleResetClick = e => {
    e.preventDefault()
    this.props.dispatch(actions.change('availabilityRequestForm.dateStart', null))
    this.props.dispatch(actions.change('availabilityRequestForm.dateEnd', null))
  }

  render() {
    const { dateStart, dateEnd } = this.props

    return (
      <>
        <div className="md:flex space-x-0 md:space-x-16 lg:space-x-32 mt-8">
          <div className="w-full md:w-7/12 lg:w-1/2">
            <div className="h-12">
              {!dateStart && !dateEnd && (
                <Label className="mb-4">
                  Select the <span className="text-orange-600">first day</span> you are available to arrive.
                </Label>
              )}
              {dateStart && !dateEnd && (
                <Label className="mb-4">
                  Select the <span className="text-orange-600">last day</span> you are available to arrive.
                </Label>
              )}

              {dateStart && dateEnd && (
                <div className="flex space-x-4 items-center">
                  <Label>Arriving:</Label>
                  <div className="flex-grow flex items-center justify-between text-lg font-semibold p-2 border border-gray-200 bg-gray-100 text-gray-600 rounded-md">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    <span>
                      {dayjs(dateStart).format('MM/DD/YYYY')} - {dayjs(dateEnd).format('MM/DD/YYYY')}
                    </span>
                    <FontAwesomeIcon icon={faTimes} onClick={this.handleResetClick} />
                  </div>
                </div>
              )}
            </div>
            <div className="mt-8">
              <DayPicker
                numberOfMonths={1}
                selectedDays={[dateStart, { from: dateStart, to: dateEnd }]}
                onDayClick={this.handleDayClick}
                showOutsideDays
                pagedNavigation
                modifiers={{
                  disabled: { before: new Date() }
                }}
                navbarElement={<Navbar />}
              />
              <Errors
                model="availabilityRequestForm.dateStart"
                messages={{
                  required: 'Select a date'
                }}
                component={props => (
                  <Card color="lightOrange" small className="inline-block mt-1">
                    <span className="text-lg font-bold">{props.children}</span>
                  </Card>
                )}
              />
            </div>
          </div>
          <div className="w-full md:w-5/12 lg:w-1/2 mt-12 md:mt-0">
            <Label>Length of stay (# Nights):</Label>

            <Control model=".stayLength" component={SemanticInput} />
            <Errors
              model="availabilityRequestForm.stayLength"
              messages={{
                required: 'Enter a stay length'
              }}
              component={props => (
                <Card color="lightOrange" small className="inline-block mt-1">
                  <span className="text-lg font-bold">{props.children}</span>
                </Card>
              )}
            />

            <RequestFormStep2ArrivalDays />
          </div>
        </div>
        <RequestFormStepButtons />
      </>
    )
  }
}
export default connected(RequestFormStep2)
